import BringYourListCard from '@components/BringYourListCard/BringYourListCard';
import {
	getCategoryCode,
	getCategoryName,
	getCategorySlug,
} from '@redux/category';
import { reportServerSideExperiment } from '@redux/experiments';
import { isBylNonAuthEntrypointsVariant1 } from '@redux/experiments/selectors/byl-non-auth-entrypoints';
import { bylNonAuthEntrypointsSelector } from '@redux/experiments/selectors/byl-non-auth-entrypoints';
import { lpSearchBarSelector } from '@redux/experiments/selectors/lp-search-bar';
import { requestQuoteCtaChangeSelector } from '@redux/experiments/selectors/request-quote-cta-change';
import { sortRelevanceModelSelector } from '@redux/experiments/selectors/sort-relevance-model';
import { getMember } from '@redux/index';
import { getConversations } from '@redux/messagedVendors/thunks';
import { getVisibleRecommendationModules } from '@redux/statePage';
import { getFooterCities, getStateCode, getStateName } from '@redux/states';
import { experiments } from '@settings';
import { PageContainer } from '@tkww/orion-web-ds-page-layout';
import { GridColumn, GridRow } from '@tkww/orion-web-ds-structure';
import { Logger } from '@utils/logger/logger';
import { CookieStorage } from 'cookie-storage';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { XO_SESSION_TOKEN } from '../../../constants/membership';
import {
	buildLocalBusinessItemListScript,
	getLandingLeadImage,
} from '../../../helpers/linkedData/localBusiness';
import { composeCanonicalUrlForPath } from '../../../helpers/seo';
import Breadcrumbs from '../../components/shared/Breadcrumbs';
import FooterLinks from '../../components/shared/FooterLinks';
import MetaContent from '../../components/shared/HelmetHeader/HelmetHeader';
import PhotoCredit from '../../components/shared/PhotoCredit';
import SearchWidget from '../../components/shared/SearchWidget';
import { AnalyticsContext } from '../../contexts/AnalyticsContext/AnalyticsContext';
import { RFQModalContextProvider } from '../../contexts/RFQModalContext/RFQModalContext';
import { WeddingsContextProvider } from '../../contexts/WeddingsContext/WeddingsContext';
import {
	generateCategoryDisplayName,
	hasUniqueHeader,
} from '../../utils/categoryContentHelper';
import {
	CLICK_THROUGH_TO_VENDOR_CATEGORY,
	FOOTER,
	STATE_LANDING_PAGE,
	STATE_LEVEL,
	categoryViewed,
} from '../../utils/tracking';
import { CITIES } from '../../utils/urlHelpers';
import AdditionalCitiesRecommendations from './AdditionalCitiesRecommendations';
import TopCitiesRecommendations from './TopCitiesRecommendations';
import Styles from './styles.scss';

export class State extends Component {
	static propTypes = {
		allCities: PropTypes.array.isRequired,
		categoryCode: PropTypes.string.isRequired,
		categoryName: PropTypes.string.isRequired,
		categorySlug: PropTypes.string.isRequired,
		categoryGuid: PropTypes.string.isRequired,
		getConversations: PropTypes.func.isRequired,
		reportServerSide: PropTypes.func.isRequired,
		lpSearchBarAssignment: PropTypes.oneOf(['control', 'variant1']),
		member: PropTypes.shape({
			id: PropTypes.string.isRequired,
		}),
		sortRelevanceModelAssignment: PropTypes.string,
		requestQuoteCtaChangeAssignment: PropTypes.oneOf([
			'control',
			'variant1',
			'variant2',
		]),
		stateCode: PropTypes.string.isRequired,
		stateName: PropTypes.string.isRequired,
		stateSlug: PropTypes.string.isRequired,
		footerCities: PropTypes.arrayOf(
			PropTypes.shape({
				name: PropTypes.string.isRequired,
				slug: PropTypes.string.isRequired,
			}).isRequired,
		),
		track: PropTypes.func.isRequired,
		bylNonAuthEntrypointsAssignment: PropTypes.oneOf([
			'control',
			'variant1',
			null,
		]),
		isBylNonAuthEntrypointsVariant1: PropTypes.bool,
		visibleRecommendationModules: PropTypes.arrayOf(PropTypes.object)
			.isRequired,
	};

	static defaultProps = {
		member: {
			id: '',
		},
		sortRelevanceModelAssignment: null,
		requestQuoteCtaChangeAssignment: null,
		lpSearchBarAssignment: null,
	};

	componentDidMount() {
		this.reportExperiments();

		const {
			categoryCode,
			stateName,
			member,
			getConversations,
			reportServerSide,
			requestQuoteCtaChangeAssignment,
			sortRelevanceModelAssignment,
		} = this.props;

		// Track category viewed
		categoryViewed(STATE_LEVEL, this.context.track, categoryCode, {
			displayLocationName: stateName,
			memberId: member ? member.id : '',
		});

		if (sortRelevanceModelAssignment) {
			Logger.log({
				log_message: `Sort Relevance Model Assignment: ${sortRelevanceModelAssignment}`,
			});
			reportServerSide(experiments.sortRelevanceModel);
		}

		if (requestQuoteCtaChangeAssignment) {
			Logger.log({
				log_message: `Request Quote CTA Change Assignment: ${requestQuoteCtaChangeAssignment}`,
			});
			reportServerSide(experiments.requestQuoteCtaChange);
		}

		if (member?.id) {
			const cookieStorage = new CookieStorage();
			const sessionToken = cookieStorage.getItem(XO_SESSION_TOKEN);
			if (sessionToken) {
				getConversations(member.id, sessionToken);
			}
		}
	}

	reportExperiments = () => {
		const {
			reportServerSide,
			universalVendorCardAssignment,
			bylNonAuthEntrypointsAssignment,
			lpSearchBarAssignment,
		} = this.props;

		if (lpSearchBarAssignment) {
			Logger.log({
				log_message: `LP Search Bar Assignment: ${lpSearchBarAssignment}`,
			});

			reportServerSide(experiments.lpSearchBar);
		}

		if (bylNonAuthEntrypointsAssignment) {
			Logger.log({
				log_message: `BYL Non-Auth Entrypoints Assignment: ${bylNonAuthEntrypointsAssignment}`,
			});

			reportServerSide(experiments.bylNonAuthEntrypoints);
		}
	};

	componentDidUpdate(prevProps) {
		const { member, getConversations } = this.props;
		// Fetch conversations when member becomes available
		if (member?.id && !prevProps.member?.id) {
			const cookieStorage = new CookieStorage();
			const sessionToken = cookieStorage.getItem(XO_SESSION_TOKEN);
			if (sessionToken) {
				getConversations(member.id, sessionToken);
			}
		}
	}

	trackClickThroughToVendorCategory = () => {
		this.context.track({
			event: CLICK_THROUGH_TO_VENDOR_CATEGORY,
			properties: {
				sourceContent: FOOTER,
				sourcePage: STATE_LANDING_PAGE,
				vendorCategoryCode: this.props.categoryCode,
			},
		});
	};

	templateDescription() {
		const { stateName, categoryName } = this.props;
		return `Research and compare ${stateName} ${categoryName} on The Knot. We offer reviews, quotes and details on vendors to ensure they match your needs to make your big day more special.`;
	}

	templateTitle() {
		const { stateName, categoryName } = this.props;
		return `${categoryName} in ${stateName}`;
	}

	render() {
		const {
			categoryGuid,
			categoryCode,
			categoryName,
			categorySlug,
			headerName,
			stateCode,
			stateName,
			stateSlug,
			footerCities,
			isBylNonAuthEntrypointsVariant1,
			visibleRecommendationModules,
		} = this.props;
		const localBusinessVendorIds = new Set();
		const localBusinessVendors = visibleRecommendationModules.flatMap(
			({ vendors }) =>
				vendors.filter((vendor) => {
					if (localBusinessVendorIds.has(vendor.id)) return false;

					localBusinessVendorIds.add(vendor.id);
					return true;
				}),
		);
		const linkedDataScripts = localBusinessVendors.length
			? [
					buildLocalBusinessItemListScript({
						id: `stateLocalBusinessLdJson-${stateCode.toLowerCase()}`,
						vendors: localBusinessVendors,
						imageForVendor: getLandingLeadImage,
					}),
				]
			: [];

		return (
			<>
				<WeddingsContextProvider>
					<RFQModalContextProvider>
						<MetaContent
							canonical={composeCanonicalUrlForPath(
								`${categorySlug}/${stateSlug}`,
							)}
							description={this.templateDescription()}
							landingPage="state"
							{...(linkedDataScripts.length > 0 && { linkedDataScripts })}
							title={this.templateTitle()}
						/>

						<div className={Styles.topBreadcrumbsWrapper}>
							<Breadcrumbs
								categoryCode={categoryCode}
								stateCode={stateCode}
								isHeader
							/>
						</div>
						<SearchWidget
							pageType={STATE_LEVEL}
							categoryCode={categoryCode}
							categoryGuid={categoryGuid}
							headerName={headerName}
							subHeader={
								hasUniqueHeader(categoryCode)
									? `${hasUniqueHeader(categoryCode).stateSubHeader}${stateName}.`
									: `Find local ${categoryName.toLowerCase()} in ${stateName} with help from The Knot.`
							}
						/>

						<PageContainer>
							{isBylNonAuthEntrypointsVariant1 && (
								<BringYourListCard
									className={Styles.bringYourListCard}
									sourceRedirect="state landing page"
								/>
							)}

							<TopCitiesRecommendations />
							<AdditionalCitiesRecommendations />

							<FooterLinks
								category={{ categoryName, categorySlug }}
								links={footerCities}
								trackHandler={this.trackClickThroughToVendorCategory}
								type={CITIES}
							/>
							<PhotoCredit categoryCode={categoryCode} />
							<GridRow>
								<GridColumn xs="12">
									<div className={Styles.bottomBreadcrumbsWrapper}>
										<Breadcrumbs
											categoryCode={categoryCode}
											stateCode={stateCode}
										/>
									</div>
								</GridColumn>
							</GridRow>
						</PageContainer>
					</RFQModalContextProvider>
				</WeddingsContextProvider>
			</>
		);
	}
}

export function mapStateToProps(state) {
	return {
		categoryCode: getCategoryCode(state),
		categoryName: getCategoryName(state),
		categorySlug: getCategorySlug(state),
		categoryGuid: state.category.id,
		footerCities: getFooterCities(state),
		headerName: generateCategoryDisplayName(state.category),
		sortRelevanceModelAssignment: sortRelevanceModelSelector(state),
		lpSearchBarAssignment: lpSearchBarSelector(state),
		member: getMember(state),
		requestQuoteCtaChangeAssignment: requestQuoteCtaChangeSelector(state),
		stateCode: getStateCode(state),
		stateName: getStateName(state),
		stateSlug: state.states.slug,
		bylNonAuthEntrypointsAssignment: bylNonAuthEntrypointsSelector(state),
		isBylNonAuthEntrypointsVariant1: isBylNonAuthEntrypointsVariant1(state),
		visibleRecommendationModules: getVisibleRecommendationModules(state),
	};
}

export const mapDispatchToProps = {
	getConversations,
	reportServerSide: reportServerSideExperiment,
};

State.contextType = AnalyticsContext;

const ConnectedState = connect(mapStateToProps, mapDispatchToProps)(State);

export default ConnectedState;
